/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from 'react';
import { Skeleton } from 'primereact/skeleton';

export const DocsLoadingSkeleton = () => {
  return (
    <div className="flex w-full h-screen surface-ground">
      <div className="w-20rem p-4 border-right-1 surface-border surface-card flex flex-column gap-3">
        <Skeleton width="100%" height="2.5rem" className="mb-4" />
        <Skeleton width="80%" height="1.5rem" />
        <Skeleton width="90%" height="1.5rem" />
        <Skeleton width="70%" height="1.5rem" />
        <Skeleton width="85%" height="1.5rem" />
        <Skeleton width="60%" height="1.5rem" />
        <div className="mt-auto">
          <Skeleton width="100%" height="3rem" />
        </div>
      </div>

      <div className="flex-1 flex flex-column w-full h-full">
        <div className="p-5 flex flex-column gap-4 w-full max-w-6xl mx-auto">
          <Skeleton width="40%" height="3rem" className="mb-2" />
          <Skeleton width="100%" height="1.5rem" />
          <Skeleton width="95%" height="1.5rem" />
          <Skeleton width="90%" height="1.5rem" />
          <Skeleton width="100%" height="15rem" className="mt-4" />
          <Skeleton width="85%" height="1.5rem" className="mt-4" />
          <Skeleton width="95%" height="1.5rem" />
        </div>
      </div>
    </div>
  );
};
